import type { CSSProperties, FC, PropsWithChildren } from 'react';
import { useTranslation } from 'next-i18next';
import { selectUserCurrency } from '@mwl/core-lib';
import { useTypedSelector } from '@/hooks';
import type { CouponSumFieldWrapperProps } from './CouponSumFieldWrapper.types';
export const CouponSumFieldWrapper: FC<PropsWithChildren<CouponSumFieldWrapperProps>> = ({
  className,
  children
}) => {
  const {
    t
  } = useTranslation('sport');
  const currency = useTypedSelector(selectUserCurrency);
  const prefixLength = t('coupon.amount_input_prefix', 'Bet')?.length;
  const postfixLength = currency?.length;
  return <div className={className} style={({
    '--input-prefix-length': prefixLength,
    '--input-postfix-length': postfixLength
  } as CSSProperties)} data-sentry-component="CouponSumFieldWrapper" data-sentry-source-file="CouponSumFieldWrapper.tsx">
      {children}
    </div>;
};